export function hasPermission(permissions, resource, action) {
  const perm = permissions.find(p => p.resource === resource);
  return perm
    ? perm.action.some(a => a?.toLowerCase() === action)
    : false;
}
